import type { ComponentType } from "react"
import type { BlockType } from "../types"
import { HeroBlockEditor } from "./HeroBlockEditor"
import { ImpactStatsBlockEditor } from "./ImpactStatsBlockEditor"
import { DonationCTABlockEditor } from "./DonationCTABlockEditor"
import { FooterBlockEditor } from "./FooterBlockEditor"
import { ParagraphBlockEditor } from "./ParagraphBlockEditor"
import { HeadingBlockEditor } from "./HeadingBlockEditor"
import { ImageBlockEditor } from "./ImageBlockEditor"
import { TeamMembersBlockEditor } from "./TeamMembersBlockEditor"
import { TimelineBlockEditor } from "./TimelineBlockEditor"
import { FormBlockEditor } from "./FormBlockEditor"
import { ContactBlockEditor } from "./ContactBlockEditor"
import { AccordionBlockEditor } from "./AccordionBlockEditor"
import { CardsBlockEditor } from "./CardsBlockEditor"
import { LogoGridBlockEditor } from "./LogoGridBlockEditor"
import { TableBlockEditor } from "./TableBlockEditor"
import { FundraisingGoalBlockEditor } from "./FundraisingGoalBlockEditor"
import { ListBlockEditor } from "./ListBlockEditor"
import { BlockquoteBlockEditor } from "./BlockquoteBlockEditor"
import { VideoBlockEditor } from "./VideoBlockEditor"
import { CalloutBlockEditor } from "./CalloutBlockEditor"
import { ImageTextBlockEditor } from "./ImageTextBlockEditor"
import { PullQuoteBlockEditor } from "./PullQuoteBlockEditor"
import { DividerBlockEditor } from "./DividerBlockEditor"
import { ButtonBlockEditor } from "./ButtonBlockEditor"
import { FileDownloadBlockEditor } from "./FileDownloadBlockEditor"
import { EmbedBlockEditor } from "./EmbedBlockEditor"
import { NewsletterSignupBlockEditor } from "./NewsletterSignupBlockEditor"
import { AuthorBioBlockEditor } from "./AuthorBioBlockEditor"
import { MapBlockEditor } from "./MapBlockEditor"
import { FallbackBlockEditor } from "./FallbackBlockEditor"

/** Props passed by BlockEditorSlot to each block editor: content + onChange + optional block */
export interface BlockEditorSlotProps {
  content?: unknown
  onChange: (content: Record<string, unknown>) => void
  block?: { id: string; section_type: string }
}

const EDITOR_MAP: Partial<
  Record<BlockType, ComponentType<BlockEditorSlotProps>>
> = {
  hero: HeroBlockEditor as ComponentType<BlockEditorSlotProps>,
  impact_stats: ImpactStatsBlockEditor as ComponentType<BlockEditorSlotProps>,
  donation_cta: DonationCTABlockEditor as ComponentType<BlockEditorSlotProps>,
  footer: FooterBlockEditor as ComponentType<BlockEditorSlotProps>,
  paragraph: ParagraphBlockEditor as ComponentType<BlockEditorSlotProps>,
  heading: HeadingBlockEditor as ComponentType<BlockEditorSlotProps>,
  image: ImageBlockEditor as ComponentType<BlockEditorSlotProps>,
  team_members: TeamMembersBlockEditor as ComponentType<BlockEditorSlotProps>,
  timeline: TimelineBlockEditor as ComponentType<BlockEditorSlotProps>,
  contact: ContactBlockEditor as ComponentType<BlockEditorSlotProps>,
  form: FormBlockEditor as ComponentType<BlockEditorSlotProps>,
  accordion: AccordionBlockEditor as ComponentType<BlockEditorSlotProps>,
  cards: CardsBlockEditor as ComponentType<BlockEditorSlotProps>,
  logo_grid: LogoGridBlockEditor as ComponentType<BlockEditorSlotProps>,
  table: TableBlockEditor as ComponentType<BlockEditorSlotProps>,
  fundraising_goal: FundraisingGoalBlockEditor as ComponentType<BlockEditorSlotProps>,
  list: ListBlockEditor as ComponentType<BlockEditorSlotProps>,
  blockquote: BlockquoteBlockEditor as ComponentType<BlockEditorSlotProps>,
  video: VideoBlockEditor as ComponentType<BlockEditorSlotProps>,
  callout: CalloutBlockEditor as ComponentType<BlockEditorSlotProps>,
  image_text: ImageTextBlockEditor as ComponentType<BlockEditorSlotProps>,
  pull_quote: PullQuoteBlockEditor as ComponentType<BlockEditorSlotProps>,
  divider: DividerBlockEditor as ComponentType<BlockEditorSlotProps>,
  button: ButtonBlockEditor as ComponentType<BlockEditorSlotProps>,
  file_download: FileDownloadBlockEditor as ComponentType<BlockEditorSlotProps>,
  embed: EmbedBlockEditor as ComponentType<BlockEditorSlotProps>,
  newsletter_signup: NewsletterSignupBlockEditor as ComponentType<BlockEditorSlotProps>,
  author_bio: AuthorBioBlockEditor as ComponentType<BlockEditorSlotProps>,
  map: MapBlockEditor as ComponentType<BlockEditorSlotProps>,
}

export function getBlockEditorComponent(
  type: BlockType
): ComponentType<BlockEditorSlotProps> {
  return EDITOR_MAP[type] ?? FallbackBlockEditor
}

export {
  HeroBlockEditor,
  ImpactStatsBlockEditor,
  DonationCTABlockEditor,
  FooterBlockEditor,
  ParagraphBlockEditor,
  HeadingBlockEditor,
  ImageBlockEditor,
  TeamMembersBlockEditor,
  TimelineBlockEditor,
  ContactBlockEditor,
  FormBlockEditor,
  AccordionBlockEditor,
  CardsBlockEditor,
  LogoGridBlockEditor,
  TableBlockEditor,
  FundraisingGoalBlockEditor,
  ListBlockEditor,
  BlockquoteBlockEditor,
  VideoBlockEditor,
  CalloutBlockEditor,
  ImageTextBlockEditor,
  PullQuoteBlockEditor,
  DividerBlockEditor,
  ButtonBlockEditor,
  FileDownloadBlockEditor,
  EmbedBlockEditor,
  NewsletterSignupBlockEditor,
  AuthorBioBlockEditor,
  MapBlockEditor,
  FallbackBlockEditor,
}
